import React from 'react'
import './index.less'

import http from 'src/helper/http'
import { setDocumentTitle } from 'src/helper/tool'
import { history } from 'src/core/router'
// import { observable, action, autorun, computed, toJS } from 'mobx'
import brower from 'src/helper/brower'
import moment from "moment"

export default class extends React.Component {
  state = {

  }

  constructor(props) {
    super(props)
  }

  async componentWillMount() {


  }

  componentDidMount() {

  }

  render() {
    let { uid } = this.props.store
    let { isRule, lang } = this.props
    return (
      <div
        style={{ transform: `translateY(${isRule ? "0" : "100vh"})` }}
        className={`his_page ${isRule ? "openPopupRank" : "none"}`} onClick={(e) => this.props.onCloseRule()}>
        <div className={`his_box2`} onClick={(e) => e.stopPropagation()}>
          <div className='title'>{lang.Rule}<img src="/img/activity/fruitgame/icon-close.png" onClick={() => this.props.onCloseRule()} /></div>
          <div className='every_rule' dangerouslySetInnerHTML={{ __html: lang.RuleDetail }} ></div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/activity/fruit1103/rule.js